<div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
  <ol class="carousel-indicators">
    <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>
    <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
    <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
  </ol>
  <div class="carousel-inner">
    <div class="carousel-item active">
      <img
        src="https://charlottefitnessequipment.com/site/wp-content/uploads/2018/12/cfe-teaser-bg-financing-1024x453.jpg"
        class="d-block w-100" alt="...">
    </div>
    <div class="carousel-item">
      <img
        src="https://generationiron.com/wp-content/uploads/2015/12/muscular-bodybuilder-exercising-with-heavy-8UPX7QH-1024x453.jpg"
        class="d-block w-100" alt="...">
    </div>
    <div class="carousel-item">
      <img src="https://www.morningtea.in/wp-content/uploads/2018/01/fitness-super-store-uk_h5146a-1024x453.jpg"
        class="d-block w-100" alt="...">
    </div>
  </div>
  <a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="sr-only">Previous</span>
  </a>
  <a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="sr-only">Next</span>
  </a>
</div>


<div class="container">
  <h1 class="box">Our Services</h1>
 
  <div class="row">
    
    <div class="col-sm-4">
    <div class="card text-white bg-info mb-3">
      <div class="card-header">Weight Training</div>
      <div class="card-body">
        <h5 class="card-title">Build Your Strength</h5>
        <p class="card-text">Strength and flexibility exercises will help you increase muscle strength, maintain bone density, improve balance and reduce joint pain Strength training can help you get stronger and look and feel better  </p>
      </div>
    </div>
    </div>

    <div class="col-sm-4">
      <div class="card text-white bg-success mb-3">
        <div class="card-header">Cardio Workout</div>
        <div class="card-body">
          <h5 class="card-title">Get Leaner</h5>
          <p class="card-text">Why its Great [cardio], burning about 220 calories in 20 minutes. Jump ropes are inexpensive, travel well, require no special skills, and can be used anywhere you have space.</p>
        </div>
      </div>
      </div>

      <div class="col-sm-4">
        <div class="card text-white bg-primary mb-3">
          <div class="card-header">CrossFit Workout</div>
          <div class="card-body">
            <h5 class="card-title">Intensity Interval Training</h5>
            <p class="card-text">The high-intensity, multi-joint movements in CrossFit may help you gain muscle strength and stamina. Adding additional weight to your workouts can further increase muscle gain by adding stress to your muscles..</p>
          </div>
        </div>
        </div>
    </div>
    </div>

    <div class="container">
      <h1 class="box">Meet Our Trainer's</h1>
      <div class="row">
        <div class="col-sm-4">
          <div class="card" >
            <img class="card-img-top" src="https://yt3.ggpht.com/a/AATXAJy-IDp5hhdJhBHb5Icxj_D-rzlhVkoyVAhWA8rooA=s900-c-k-c0x00ffffff-no-rj" alt="Card image cap">
            <div class="card-body">
              <h5 class="card-title">Jeff nippard</h5>
              <p class="card-text">Hello everyone! I'm a Canadian natural pro bodybuilder and internationally-qualified powerlifter with a BSc in bio,chemistry and a passion for science.</p>
              
            </div>
          </div>
        </div>

        <div class="col-sm-4">
          <div class="card" >
            <img class="card-img-top" src="https://i.pinimg.com/736x/ab/7e/37/ab7e379e4d15a5a24ca90173e6008125.jpg" alt="Card image cap">
            <div class="card-body">
              <h5 class="card-title">Matt Morsia</h5>
              <p class="card-text">My name is Matt and I do fitness. I also eat quite a lot.. I train as a bodybuilder and use my knowledge to help others achieve their training goals. Seeing someone lose weight, build muscle and to get stronger </p>
              
            </div>
          </div>
        </div>

        <div class="col-sm-4">
          <div class="card" >
            <img class="card-img-top" src="https://whoabella.com/wp-content/uploads/2019/09/BUTTERMORE.jpg" alt="Card image cap">
            <div class="card-body">
              <h5 class="card-title">Stephanie buttermore</h5>
              <p class="card-text">Hello there! My name is Stephanie Buttermore and I'm a 29 year old cancer research scientist who loves fitness I mix science and fitness into all facets of life! I currently do cancer research but LOVE to workout and eat good food!.</p>
              
            </div>
          </div>
        </div>
      </div>
    </div>
      
  
  
   